// import { Link } from "react-router-dom";

import { marked } from "marked";
// import useMobile from "../hooks/useMobile";

const ChooseUsOne = (props) => {
  const { chooseUsData } = props;
  // const mobile = useMobile();
  const rawDescription = chooseUsData[0]?.description || "";
  const lines = rawDescription.split(/<br\s*\/?>|<\/?p>/gi);
  const paragraphLines = lines.filter((line) => !line.trim().startsWith("-"));
  const listLines = lines.filter((line) => line.trim().startsWith("-"));

  const descriptionParagraph = marked.parseInline(paragraphLines.join(" "));
  const descriptionListItems = listLines.map((line, index) => {
    const text = line.replace(/^-\s*/, "");
    const html = marked.parseInline(text);

    return (
      <li
        key={index}
        className="flex-align gap-12 mb-16"
        data-aos="fade-up-left"
        data-aos-duration={200 + index * 200}
        style={{ alignItems: "start" }}
      >
        <span className="flex-shrink-0 text-xl text-main-600 d-flex mt-2">
          <i className="ph-bold ph-checks" />
        </span>
        <span
          className="flex-grow-1 text-neutral-500"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </li>
    );
  });

  return (
    <section className="choose-us pt-120 position-relative z-1 mash-bg-main mash-bg-main-two">
      {/* <img
        src='assets/images/shapes/shape2.png'
        alt=''
        className='shape one animation-scalation'
      /> */}
      {/* <img
        src='assets/images/shapes/shape2.png'
        alt=''
        className='shape six animation-scalation'
      /> */}
      <div className="container">
        <div className="row gy-4">
          <div className="col-xl-6">
            <div className="choose-us__content" id="chooseus">
              <div className="mb-40">
                <div className="flex-align gap-8 mb-16 wow bounceInDown">
                  <span className="text-main-600 text-2xl d-flex">
                    <i className="ph-bold ph-book-open" />
                  </span>
                  <h5 className="text-main-600 mb-0">
                    {chooseUsData[0]?.snippet}
                  </h5>
                </div>
                <h2 className="mb-24  wow bounceIn">
                  {chooseUsData[0]?.title}
                </h2>
                <p
                  className="text-neutral-500 text-line-2 wow bounceInUp"
                  dangerouslySetInnerHTML={{ __html: descriptionParagraph }}
                />

                {descriptionListItems.length > 0 && (
                  <ul className="wow bounceInUp">{descriptionListItems}</ul>
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div
              // className={`${!mobile && "choose-us__thumbs"} position-relative`}
              className={`position-relative`}
            >
              <div className="text-end" data-aos="zoom-out">
                <div className="d-sm-inline-block d-block position-relative">
                  <img
                    src={
                      chooseUsData[0]?.primary_image[0]?.media?.url &&
                      `${process.env.REACT_APP_cmsUrl}${chooseUsData[0]?.primary_image[0]?.media?.url}`
                    }
                    alt=""
                    className="choose-us__img"
                    data-tilt=""
                    data-tilt-max={16}
                    data-tilt-speed={500}
                    data-tilt-perspective={5000}
                    data-tilt-full-page-listening=""
                  />
                </div>
              </div>
              {/* <div
                className="animation-video"
                data-aos="zoom-in"
                style={{ maxWidth: mobile ? "100%" : "85%" }}
              >
                <img
                  src={
                    chooseUsData[0]?.secondary_image[0]?.media?.url &&
                    `${process.env.REACT_APP_cmsUrl}${chooseUsData[0]?.secondary_image[0]?.media?.url}`
                  }
                  alt=""
                  className="border border-white border-1"
                  data-tilt=""
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChooseUsOne;
